import { notification } from "antd";
import { IProductItem } from "../IRequestModel/ECatalog/IProductItemModel";
import moment from "moment";
import 'moment/locale/th';

const eCatalogName = 'ecatLastViewItem';
export function SetViewItemToLocalStorage(productItem: any) {
    let items = [];

    items = localStorage.getItem(eCatalogName) != null ? JSON.parse(localStorage.getItem(eCatalogName)) : [];
    if (items.length > 0)
    {
        //check exist
        //const itemExist = items.find((x) => x.itemId === productItem.itemId && x.title === productItem.title);
        let itemExist = items.findIndex((x) => x.itemId === productItem.itemId && x.title === productItem.title);
        if (itemExist > -1){
            items.splice(itemExist, 1);
        }
    }

    productItem.stampdate = new Date();
    items.push(productItem)

    localStorage.setItem(eCatalogName, JSON.stringify(items));
}

export function GetViewItemFromLocalStorage(){
    let items = [];

    items = localStorage.getItem(eCatalogName) != null ? JSON.parse(localStorage.getItem(eCatalogName)) : [];

    return items;
}

export function NumberFormatter(value){
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      return numberFormatter.format(value);
}

export function MapsDataToProductObject(datasource: any){
    let productItem: IProductItem[] = [];

    //let productShuffle = props.limitItem != undefined && data != null ? shuffle(data).slice(0, props.limitItem) : data
    datasource?.map((x:any) => {
        let imageData = x.ItemImage; //!= null ? JSON.parse(x.ItemImage) : null;
        let item : IProductItem = {
            rowKey: x.RowNo,
            id: x.RowID,
            itemId: x.ItemID,
            title: x.ItemName,
            thumbnail: imageData,//x.ItemImage, 
            defaultthumbnail: imageData != null && imageData.length > 0 ? imageData[0].ItemPicPath : "", //x.itemImage != null && x.itemImage.length > 0 ? x.itemImage[0].ItemPicPath : "",
            description: x.ItemDescription,
            price: x.ItemPrice,
            //itemStock: x.ItemStock != undefined ? x.ItemStock : 0,
            itemProperties: x.ItemPropertise,
            itemUnit: x.ItemUnit,
            itemType: x.ItemType,
            //sellerID: x.SellerID,
            isFavorite: x.IsFavorite,
            //sellerName: x.SellerName,
            //categoryGroupID: x.CategoryGroupID,
            categoryGroupName: x.CategoryGroupName,
            categoryGroupCode: x.CategoryGroupCode,
            GLAccountCode: x.GLAccountCode,
            GLAccountName: x.GLAccountName,
            categoryType: x.CategoryType,
            vendorCode: x.VendorCode,
            vendorName: x.VendorName,
            vendorAddress: x.VendorAddress,
            vendorPaymentMethod: x.VendorPaymentMethod,
            vendorPaymentCondition: x.VendorPaymentCondition,
            vendorPaymentText: x.VendorPaymentText,
            vendorBank: x.VendorBank,
            vendorMobileNo: x.VendorMobileNo,
        }

        productItem.push(item);
    })

    return productItem;
}

export function NotificationAddCartSuccess(){
    notification.success({
        message: 'รายการสินค้าถูกเพิ่มแล้ว',
        // description:
        //   'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
        placement: "top",
    });
}

export function GetFiscalYear(){
    let checkDate =  moment(moment ().year().toString() + '-10-01');
    let year = moment().add(543, 'year').format('YYYY');
    if (moment() >= checkDate)
        year = (parseInt(year) + 1).toString(); 

    return year;
}